import { generatePath, Link } from "react-router-dom";
import { useTranslate } from "../../../../../language/i18n";
import calculateSalesPrice from "../../../../../utils/calculateSalesPrice";
import pages from "../../../../../utils/pages";
import styles from "./ProductGroup.module.scss";

export type ProductGroupItem = {
  productId?: string;
  itemNumber: string;
  name?: string;
  sequenceNumber?: number;
  maxPrice?: number;
  availableBalance?: number;
  isOrderBlocked?: boolean;
};

type Props = {
  item: ProductGroupItem;
  showPrice: boolean;
  currency?: string;
  decimals?: number;
};

const ProductGroupRow = ({ item, showPrice, currency, decimals }: Props) => {
  const translate = useTranslate();

  return (
    <div className={styles.row}>
      <div className={styles.info}>
        <div>
          {translate("PRODUCT_NUMBER_SHORT")}:{" "}
          {item.productId ? (
            <Link
              to={{
                pathname: generatePath(pages.PRODUCT_DETAIL.PATH, { product: item.productId }),
                state: { referrer: `${window.location.pathname}${window.location.search}` },
              }}
              className={styles.link}
            >
              {item.itemNumber}
            </Link>
          ) : (
            item.itemNumber
          )}
        </div>
        {item.name && (
          <div>
            {translate("DESCRIPTION")}: {item.name}
          </div>
        )}
      </div>
      <div className={styles.numeric} data-label={translate("AVAILABLE_BALANCE")}>
        {item.availableBalance ?? 0}
      </div>
      {showPrice && (
        <div className={styles.numeric} data-label={translate("MAX_PRICE")}>
          {item.maxPrice != null
            ? `${calculateSalesPrice(item.maxPrice, 1, decimals ?? 2)} ${currency ?? "SEK"}`
            : null}
        </div>
      )}
    </div>
  );
};

export default ProductGroupRow;
